import * as React from 'react';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';

import type {TextAutomation as TextAutomationFragment} from 'nutshell-graphql-types';

import {TEXT_AUTOMATIONS} from '../../constants';

import {Delay, SendFrom} from './rows';
import {SalesAutomationCard} from './sales-automation-card';

import styles from './sales-automation-card.module.css';

type Props = {
    textAutomation: TextAutomationFragment;
    parentId: string;
};

export function SalesAutomationCardTextAutomation(props: Props) {
    return (
        <SalesAutomationCard
            type={TEXT_AUTOMATIONS}
            borderColor={colors.grey}
            isHidden={false}
            parentId={props.parentId}
            entityId={props.textAutomation.id}
        >
            <div className='full-width'>
                <div className={classnames('truncate', styles.title)}>
                    Send: <span className='font-bold'>{props.textAutomation.content}</span>
                </div>
                <Delay
                    delay={props.textAutomation.delay}
                    entersStage={props.textAutomation.stage}
                />
                <SendFrom sendFromUser={props.textAutomation.sendFromUser} />
            </div>
        </SalesAutomationCard>
    );
}
